import React, { useState, useRef } from "react";
import Dialog from "@material-ui/core/Dialog";
import { withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import DataObjects from "../../../../src/components/LeftNavigation/DataObjects/DataObjects";
import ServiceTreeView from "./ServiceTreeView";
import MuiDialogActions from "@material-ui/core/DialogActions";
import MuiDialogContent from "@material-ui/core/DialogContent";
import { useTranslation } from "react-i18next";

function WebServiceBackdrop(props) {
  const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      minHeight: "460px",
      minWidth: "850px",
      borderRadius: "2px",
      overflowX: "hidden",
    },
    dialogHeader: {
      fontWeight: "bold",
      padding: "10px",
    },
    dialogSubHeading: {
      width: "50%",
      height: "36px",
      backgroundColor: "#F0F0F0",
      padding: "10px",
      fontSize: "12px",
      fontWeight: "bold",
      border: "1px solid #d7d7d7",
    },
    dialogFooter: {
      position: "relative",
      display: "flex",
      "justify-content": "end",
      padding: "10px",
      bottom: 0,
      width: "100%",
      "background-color": "#f0f0f0",
    },
    dialogContent: {
      display: "flex",
      height: "350px",
      width: "50%",
      "border-right": "1px solid #d7d7d7",
      fontFamily: "Open Sans !important",
      fontSize: "14px !important",
      overflowY: "auto",
    },
    dialogContent1: {
      display: "flex",
      height: "350px",
      width: "50%",
      "border-right": "1px solid #d7d7d7",
      fontFamily: "Open Sans !important",
      fontSize: "14px !important",
    },
    cancelButton: {
      cursor: "pointer",
      "border-radius": "0px",
      border: "1px solid grey",
      width: "60px",
      height: "30px",
      margin: "0px 10px",
    },
  }));
  const DialogContent = withStyles((theme) => ({
    root: {
      padding: 0,
      fontFamily: "Open Sans",
      fontSize: "14px",
    },
  }))(MuiDialogContent);
  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: 0,
    },
  }))(MuiDialogActions);

  const classes = useStyles();
  const [showMapButton, setShowMapButton] = useState(false);
  const dataRef = useRef();
  const mappedServiceRef = useRef();
  const { t } = useTranslation();
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  return (
    <>
      <Dialog
        open={props.mappingDialogOpen}
        classes={{ paper: classes.dialogPaper }}
        className={"formBuilder_main_app"}
        style={{ direction: translationStyles1 ? "rtl" : "ltr" }}
      >
        <div>
          <div className={classes.dialogHeader}>
            <span>{t("Input Parameter Mapping")}</span>
          </div>
        </div>
        <div>
          <div style={{ display: "flex" }}>
            <div className={classes.dialogSubHeading}>
              {t("Select the controls you want to map")}
            </div>
            <div
              className={classes.dialogSubHeading}
              style={{ borderLeft: "none" }}
            >
              {t("Select the parameters you want to map")}
            </div>
          </div>
        </div>
        <DialogContent>
          <div>
            <div style={{ display: "flex" }}>
              <div className={classes.dialogContent1}>
                <DataObjects
                  appId={props.appId}
                  containerId={props.containerId}
                  isWS={true}
                  dataRef={dataRef}
                  mappedServiceRef={mappedServiceRef}
                />
              </div>
              <div className={classes.dialogContent}>
                <ServiceTreeView
                  data={props.selectedWebService}
                  rowData={props.rowData}
                  showMapButton={showMapButton}
                  setShowMapButton={setShowMapButton}
                  dataRef={dataRef}
                  mappedServiceRef={mappedServiceRef}
                ></ServiceTreeView>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <div className={`${classes.dialogFooter}`}>
            <button
              className={`${classes.cancelButton} tertiary`}
              onClick={() => props.setMappingDialogOpen(false)}
            >
              {t("Cancel")}
            </button>
            <button
              className={"primary"}
              style={{
                backgroundColor: "#0072C6",
                color: "white",
                border: "none",
                borderRadius: "3px",
                cursor: "pointer",
              }}
              onClick={() => props.setMappingDialogOpen(false)}
            >
              {t("Done")}
            </button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default WebServiceBackdrop;
